import { render, staticRenderFns } from "./PurchaseAdd.vue?vue&type=template&id=451f1c96&scoped=true"
import script from "./PurchaseAdd.vue?vue&type=script&lang=js"
export * from "./PurchaseAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f1c96",
  null
  
)

export default component.exports